import { trpc } from '@/shared/api';

/** 결제 가능한 주문에서만 켜는 계좌이체 선택 정보. */
export const useBankTransferOptionQuery = (
  orderId: string,
  options: { readonly enabled?: boolean } = {},
) =>
  trpc.payments.getBankTransferOption.useQuery(
    { orderId },
    { enabled: options.enabled ?? true, retry: false },
  );
